"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MonthlySavingsState = /** @class */ (function () {
    function MonthlySavingsState() {
        this.isValidMonthlySavings = false;
        this.showMonthlySavingsModal = false;
    }
    return MonthlySavingsState;
}());
exports.default = MonthlySavingsState;
//# sourceMappingURL=MonthlySavingsState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/MonthlySavings/MonthlySavingsState.js
// module id = 2257
// module chunks = 8